import React from 'react'
import { Link } from 'react-router-dom';
import './Css/service.css'

const ServiceList = [
  {
    id: 1,
    sub: "Hydraulic Machine Repair:",
    para: "Comprehensive repair services to restore your hydraulic machines to optimal functionality.",
  },
  {
    id: 2,
    sub: "Industrial Equipment Maintenance:",
    para: "Regular maintenance to prevent downtime and extend the lifespan of your equipment.",
  },
  {
    id: 3,
    sub: "Reworking and Upgrades:",
    para: "Enhancing and upgrading machinery to meet the latest industry standards and improve efficiency. We pride ourselves on our meticulous attention to detail and our ability to provide customized solutions tailored to your specific needs. Our goal is to ensure your equipment performs reliably and efficiently, minimizing downtime and maximizing productivity.",
  },
  {
    id: 4,
    sub: "Quality Assurance:",
    para: "At Bharath Engineering Works, we guarantee perfection. Our stringent quality control processes ensure that every service we provide meets the highest standards of excellence. We believe in quality over quantity, ensuring that each job is done right the first time."
  },
  {
    id: 5,
    sub: "Service:",
    para: "For more details or to request our services, please click the service button below. Fill out the form with your details, and one of our representatives will get back to you promptly."
  }
];
const Service = () => {
  return (
    <>
      <div className="service-container">
        {/* <hr /> */}
        <div id="phead">Service:</div>
        <h1 className="service-heading">
          Welcome to Bharath Engineering Works
        </h1>
        <br />
        <h2 className="service-subheading">
          Exceptional Hydraulic and Industrial Equipment Services
        </h2>
        <p>
          At Bharath Engineering Works, we specialize in providing top-tier
          services for hydraulic machines and industrial equipment. Our
          commitment is to deliver unparalleled quality with a focus on
          perfection over quantity. Whether you need repairs, reworking, or
          routine maintenance, our expert technicians ensure your machinery
          operates at peak performance.
        </p>
        <br />
        <h2 className="service-heading">Our Services:</h2>
        {
          ServiceList.map((lis)=>{
            return (
              <>
                <h2 key={lis.id} className="service-subheading">{lis.sub}</h2>
                <p>{lis.para}</p>
                <br />
              </>
            );
          })
        }
            <div className="butt">
              <Link className='enq' to={"/contact"}>Enquire Now</Link>
            </div>
        <p>
          For further inquiries or personalized assistance, do not
          hesitate to contact us. Your satisfaction is our top priority.
        </p>
      </div>
    </>
  );
}

export default Service